import { appConfig } from 'config/appConfig';

const { envLabel } = appConfig;

export const resources = {
  email: {
    title: 'Email Nurture Copy',
    description: 'Use this email copy to send to your clients',
    data: [{
      order: '1',
      title: 'Email Nurture for Your Clients',
      thumbnail: '/assets/images/email_thumbnail.jpg',
      content: '/assets/files/Email Drip for DSC.docx',
      badge_label: 'Email Copy',
      summary: 'This email nurture sequence spans six months and comprises four strategically timed emails plus an SMS to inform clients about their eligibility to apply for an FSL loan.',
    }],
  },
  guide: {
    title: 'Guides',
    description: 'Expert tips for compelling marketing messages',
    data: [
      {
        order: '1',
        title: "Messaging Guide for DSC's",
        thumbnail: '/assets/images/guide_thumbnail.jpg',
        content: '/assets/files/DSC Messaging Guide.pptx',
        badge_label: 'Guide',
        summary: 'This guide equips you with a strategic framework to effectively market your services alongside Freshstart Lending, showcasing a comprehensive approach to engage with potential clients.',
      },
      {
        order: '2',
        title: 'Social Media Marketing Handbook',
        thumbnail: '/assets/images/social_media_guide_thumbnail.png',
        content: '/assets/files/Social Media Marketing Handbook.pdf',
        badge_label: 'Guide',
        summary: "Elevate your social media marketing with Freshstart Lending's comprehensive guide. Learn strategies for audience segmentation, hashtag optimization, and impactful content creation. Master best practices to enhance engagement and drive results.",
      },
      {
        order: '3',
        title: 'SMS (Short Message Service) Marketing Handbook',
        thumbnail: '/assets/images/sms_guide_thumbnail.png',
        content: '/assets/files/SMS Marketing Handbook.pdf',
        badge_label: 'Guide',
        summary: "Enhance your SMS marketing with Freshstart Lending's essential guide. Uncover strategies, compliance guidelines, and effective messaging techniques for impactful SMS campaigns. Learn to craft concise messages and adhere to regulations for optimal results.",
      },
      {
        order: '4',
        title: 'Email Marketing Handbook',
        thumbnail: '/assets/images/email_guide_thumbnail.png',
        content: '/assets/files/Email Marketing Handbook.pdf',
        badge_label: 'Guide',
        summary: "Discover LendingUSA's email marketing guide. Master audience segmentation, deliverability, compliance, and more. Access ready-to-use copy and promotional items for success.",
      },
      {
        order: '5',
        title: 'Overview for Sales Agents',
        thumbnail: '/assets/images/sales_overview_guide_thumbnail.png',
        content: '/assets/files/Overview for Sales & Agents.pdf',
        badge_label: 'Guide',
        summary: "Master promoting Freshstart Lending with our quick guide. Help clients consolidate debt easily after completing a debt settlement program with LendingUSA's expert tips.",
      },
    ],
  },
  landing_page: {
    title: 'Landing Pages',
    description: 'Utilize these landing pages in your marketing materials',
    data: [{
      order: '1',
      title: 'Freshstart Landing Page',
      thumbnail: '/assets/images/landingpage_thumbnail.jpg',
      content: `https://${envLabel && (envLabel === 'dev' || envLabel === 'stage') ? 'next.' : ''}lendingusa.com/freshstart-lending-dsc/`,
      badge_label: 'Landing Page',
      summary: 'This landing page serves as a comprehensive resource, guiding your debt settlement clients through the intricacies of the Freshstart Lending program.',
    }],
  },
};



// WEBPACK FOOTER //
// ./src/containers/pages/MarketingResources/data/resources.js